import RecaptchaController from "../controllers/recaptcha_controller.js";
import SignInController from "../controllers/sign_in_controller.js";

Stimulus.register("recaptcha", RecaptchaController);
Stimulus.register("sign-in", SignInController);
